import CallToAction from "../components/CallToAction"
import Feature from "../components/Feature"
import HeroSection from "../components/HeroSection"
import MarketRates from "../components/MarketRates"



function Home() {

  return (
    <>
      <HeroSection/>
      <Feature/>
      <MarketRates/>
      <CallToAction/>
     
     {/*
      <OurProducts/>
      <ProductTabs/>
      <ProductFiltering/>
      <Products/>
      <CustomProducts/>
      */}
        
    </>
  )
}

export default Home
